var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('block-title',{staticClass:"block-title",attrs:{"title":"其他信息"}},[_c('form-item',_vm._b({attrs:{"form-fef":"otherInfo","form":_vm.form,"rules":_vm.rules,"field-list":_vm.fieldList}},'form-item',_vm.$attrs,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }